import { render, staticRenderFns } from "./newpatientdata.vue?vue&type=template&id=50e36d0c&scoped=true"
import script from "./newpatientdata.vue?vue&type=script&lang=js"
export * from "./newpatientdata.vue?vue&type=script&lang=js"
import style0 from "./newpatientdata.vue?vue&type=style&index=0&id=50e36d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e36d0c",
  null
  
)

export default component.exports